import axios from 'axios';
import store from '../../store/index';

export default {
	list(deleted) {
		return axios.get(`/api/plugins?deleted=${deleted}`);
	},
	listKeys() {
		return axios.get(`/api/plugins/keys`);
	},
	create(plugin) {
		return axios.post(`/api/plugins/`, plugin);
	},
	update(plugin) {
		return axios.patch(`/api/plugins/${plugin.id}`, plugin);
	},
	updateName(plugin) {
		return axios.patch(`/api/plugins/${plugin.id}/name`, plugin);
	},
	updateConfig(plugin) {
		return axios.patch(`/api/plugins/${plugin.id}/config`, plugin);
	},
	delete(pluginId) {
		return axios.delete(`/api/plugins/${pluginId}`);
	},
	getQualifications() {
		return axios.get(`/api/qualifications`);
	},
};
